import React from 'react';
import Tabs from './components/Tabs';
import Filters from './components/Filters';
import Table from './components/Table';
import PaginationTemplate from '../../components/PaginationTemplate';
import { useFetchPayments } from '../../hooks/redux';
import css from './PaymentPage.module.scss';

const PaymentPage = () =>  {
  useFetchPayments();

  return (
    <section className={css.root}>
      <Tabs />
      <Filters />
      <Table />
      <section className={css.pagination}>
        <PaginationTemplate />
      </section>
    </section>
  );
}

export default PaymentPage;
